import { Action, createReducer, on } from '@ngrx/store';
import {
  setVisitorLimits,
  setVisitorLoading,
  setVisitorStartDate,
  incrementVisitorSearchCount,
  incrementVisitorAILettersCount,
} from '@fund-base/store/actions/visitors.action';
import { initialVisitorsState } from '@fund-base/store/state/visitors.state';
import {
  incrementAILettersCount,
  incrementSearchCount,
  setUsageStartDate,
  updateVisitorLimits,
} from '@fund-base/utils/helpers/visitors/visitors.helpers';

export const featureVisitorsKey = 'visitors';

const _visitorsReducer = createReducer(
  initialVisitorsState,
  on(setVisitorLoading, (state, { loading }) => ({ ...state, loading })),
  on(setVisitorStartDate, (state, { startDate }) => {
    setUsageStartDate(startDate);
    return { ...state, startDate };
  }),
  on(setVisitorLimits, (state, { limits }) => {
    updateVisitorLimits(limits);
    return { ...state, limits };
}),
  on(incrementVisitorSearchCount, state => {
    incrementSearchCount();
    return {
      ...state,
      limits: {
        ...state.limits,
        dailySearches: {
          ...state.limits.dailySearches,
          used: state.limits.dailySearches.used + 1,
        },
      },
    };
  }),
  on(incrementVisitorAILettersCount, state => {
    incrementAILettersCount();
    return {
      ...state,
      limits: {
        ...state.limits,
        dailyAiLetters: {
          ...state.limits.dailyAiLetters,
          used: state.limits.dailyAiLetters.used + 1,
        },
      },
    };
  })
);

export function visitorsReducer(state: any, action: Action) {
  return _visitorsReducer(state, action);
}
